import React from 'react'
import { useCarouselSlotStyles } from './carousel-slot.styles'
import PropTypes from 'prop-types'

const CarouselSlotComponent = ({ order, children }) => {
  const classes = useCarouselSlotStyles({ order })
  return <div className={classes.carouselSlot}>{children}</div>
}

CarouselSlotComponent.prototype = {
  order: PropTypes.number.isRequired,
  children: PropTypes.node.isRequired
}

export const CarouselSlot = CarouselSlotComponent
